import { forwardRef, type MouseEventHandler } from 'react';

import { ChatCircle } from '@phosphor-icons/react/dist/ssr';
import classNames from 'classnames';

import type { PostCommentsData } from '@/types';

type CommentButtonProps = {
  data: PostCommentsData;
  onClick?: MouseEventHandler;
  styles?: any;
  iconSize?: number;
};

export const CommentButton = forwardRef<HTMLButtonElement, CommentButtonProps>(
  ({ data, onClick, styles, iconSize = 20 }, ref) => {
    return (
      <button ref={ref} type="button" onClick={onClick} className={classNames('flex justify-center', styles?.button)}>
        <ChatCircle size={iconSize} />
        {typeof data?.commentsCount !== 'undefined' ? data.commentsCount : ''}
      </button>
    );
  },
);

CommentButton.displayName = 'CommentButton';
